import {
  Box,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { FC } from "react";
import JobDescription from "./JobDescription";

interface IJobDescriptionModal {
  jobData: any;
  isOpen: boolean;
  handleOpen: () => void;
}

const JobDescriptionModal: FC<IJobDescriptionModal> = ({
  jobData,
  isOpen,
  handleOpen,
}) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        // closeOnOverlayClick={false}
        onClose={() => handleOpen()}
        isCentered
        size={{
          base: "sm",
          md: "xl",
          // lg: "xl",
        }}
      >
        <ModalOverlay />
        <ModalContent px={{ base: 6, md: 10 }} pb={6}>
          <ModalHeader ml={2}>
            <ModalCloseButton />
          </ModalHeader>
          <Box pr={2} overflowY="auto" maxH="75vh">
            <JobDescription jobData={jobData} />
          </Box>
        </ModalContent>
      </Modal>
    </>
  );
};

export default JobDescriptionModal;
